<template>
  <div class="g-core-image-upload-btn">
    <slot>{{ text }}</slot>
    <form
      class="g-core-image-upload-form"
      v-show="!hasImage"
      method="post"
      enctype="multipart/form-data"
      action=""
      style=""
    >
      <input
        :disabled="uploading"
        :name="name"
        :multiple="multiple"
        type="file"
        :accept="inputAccept"
        @change="change"
      />
    </form>
  </div>
</template>
<style>
  .g-core-image-upload-btn{
    position: relative;
    overflow: hidden;
  }
  .g-core-image-upload-form{
    position: absolute;
    left:0;
    right: 0;
    top:0;
    bottom:0;
    width: 100%;
    height: 100%;
    min-height: 61px;
    opacity: 0;
  }
  .g-core-image-upload-form input{
    width: 100%;
    height: 100%;
  }
  .g-core-image-upload-container{
    position: absolute;
    background: #111;
    z-index: 900;
  }
  .g-core-image-upload-modal{
    position: absolute;
    left:0;
    right:0;
    width: 100%;
    height: 100%;
    border:1px solid #ccc;
    z-index: 899;
  }
  .dropped{
    border:4px solid #ea6153;
  }
  .g-core-image-corp-container{
    z-index: 1900;
    position:fixed;
    left:0;
    right:0;
    top:0;
    bottom: 0;
    background: rgba(0,0,0,.9);
    color:#f1f1f1;
  }
  .g-core-image-corp-container .image-aside{
    position: absolute;
    right: 30px;
    left:30px;
    top:60px;
    bottom:20px;
    text-align: center;
  }
  .g-core-image-corp-container .image-aside img{
    max-width: 100%;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .g-core-image-corp-container .info-aside{
    position: absolute;
    left:0;
    right: 0;
    top:0;
    height: 40px;
    padding-left: 10px;
    padding-right: 10px;
    background: #fefefe;
    color:#777;
  }
  .g-core-image-corp-container .btn-groups{
    text-align: right;
    margin: 5px 0 0;
  }
  .g-core-image-corp-container .btn{
    display: inline-block;
    padding: 0 15px;
    height: 32px;
    margin-left: 15px;
    background: #fff;
    border:1px solid #ccc;
    border-radius: 2px;
    font-size: 13px;
    color:#222;
    line-height: 32px;
    transition: all .1s ease-in;
  }
  .g-core-image-corp-container .btn:hover{
    border:1px solid #777;
    box-shadow: 0 1px 3px rgba(0,0,0,.05);
  }
  .g-core-image-corp-container .btn:active{
    background: #ddd;
  }
  .g-core-image-corp-container .btn:disabled{
    background: #eee !important;
    border-color:#ccc;
    cursor: not-allowed;
  }
  .g-core-image-corp-container .btn-upload{
    background: #27ae60;
    border-color:#27ae60;
    color:#fff;
  }
  .g-core-image-corp-container .btn-upload:hover{
    background: #2dc26c;
    border-color:#27ae60;
    box-shadow: 0 1px 3px rgba(0,0,0,.05);
  }

</style>
<script>
import xhr from "core-image-xhr";
import daycaca from "daycaca";
// var overflowVal = ''
export default {
  props: {
    url: {
      type: String
    },
    text: {
      type: String,
      default: "Upload Image"
    },
    extensions: {
      type: String,
      default: "png,jpg,jpeg,gif,svg,webp"
    },
    inputOfFile: {
      type: String,
      default: "files"
    },
    maxFileSize: {
      type: Number,
      default: 1024 * 1024 * 100
    },
    maxWidth: {
      type: Number
    },
    maxHeight: {
      type: Number
    },
    fixedWidth: {
      type: Number
    },
    fixedHeight: {
      type: Number
    },
    inputAccept: {
      type: String,
      default: "image/jpg,image/jpeg,image/png,image/gif"
    },
    isXhr: {
      type: Boolean,
      default: true
    },
    headers: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    multipleSize: {
      type: Number,
      default: 0
    },
    minWidth: {
      type: Number,
      default: 50
    },
    compress: {
      type: [Number, String],
      default: 0
    },
    credentials: {
      type: [String, Boolean],
      default: true
    }
  },
  data() {
    return {
      files: [],
      hasImage: false,
      options: this.props,
      uploading: false,
      image: {
        src: "",
        width: 24,
        height: 24,
        minProgress: 0.05
      },
      successCount: 0,
      successArr: [],
      failCount: 0,
      failArr: [],
      computedCount: 0
    };
  },

  computed: {
    name() {
      return this.inputOfFile;
    }
  },

  methods: {
    __dispatch(name, res, data) {
      this.$emit && this.$emit(name, res, data);
    },

    __find(el) {
      return this.$el.querySelector(el);
    },

    change(e) {
      let fileVal = e.target.value.replace(/C:\\fakepath\\/i, "");
      let fileExt = fileVal.substring(fileVal.lastIndexOf(".") + 1);
      const extensionsArr = this.extensions.split(",");
      if (extensionsArr.length > 1) {
        var reg = new RegExp("^[" + extensionsArr.join("|") + "]+$", "i");
        if (!reg.test(fileExt)) {
          return this.__dispatch("errorhandle", "TYPE ERROR");
        }
      }

      for (var key in e.target.files) {
        if (e.target.files[key].size > this.maxFileSize) {
          var formatSize;
          if (parseInt(this.maxFileSize / 1024 / 1024) > 0) {
            formatSize = (this.maxFileSize / 1024 / 1024).toFixed(2) + "MB";
          } else if (parseInt(this.maxFileSize / 1024) > 0) {
            formatSize = (this.maxFileSize / 1024).toFixed(2) + "kB";
          } else {
            formatSize = this.options.maxFileSize.toFixed(2) + "Byte";
          }
          console.warn("图片大小超出闲置" + formatSize);
          return this.__dispatch(
            "errorhandle",
            "图片大小超出限制" + formatSize
          );
        }
      }

      if (this.multipleSize > 0 && e.target.files.length > this.multipleSize) {
        console.warn("图片最大数量为" + this.multipleSize + "张");
        return this.__dispatch(
          "errorhandle",
          "图片最大数量为" + this.multipleSize + "张"
        );
      }

      this.files = e.target.files;

      this.__dispatch("imagechanged", this.files);
      console.log("文件:", this.files);
      for (let file of this.files) {
        if (this.compress && file["type"] !== "image/gif") {
          daycaca.compress(file, 100 - this.compress, code => {
            this.tryAjaxUpload("", true, code, file);
          });
        } else {
          this.tryAjaxUpload("", false, "", file);
        }
      }
    },

    // use ajax upload  IE10+
    tryAjaxUpload(callback, isBinary, base64Code, file) {
      const self = this;
      this.__dispatch("imageuploading", this.files[0]);
      const done = function(res) {
        if (typeof callback === "function") {
          callback();
        }
        console.log("done结果", res);
        self.computedCount++;
        if (res.status == 200) {
          self.successCount++;
          self.successArr.push(res.data);
        } else {
          self.failCount++;
          self.failArr.push(res);
        }

        console.log("总数和成功数：", self.files.length, self.successCount);
        if (
          self.files.length == self.computedCount &&
          self.files.length == self.successCount
        ) {
          self.__dispatch("imageuploaded", self.successArr, self.data);
          self.successCount = 0;
          self.computedCount = 0;
          self.failCount = 0;
          self.failArr = [];
          self.successArr = [];
          self.uploading = false;
        } else if (
          self.files.length == self.computedCount &&
          self.files.length != self.successCount
        ) {
          console.error(self.failArr);
          self.__dispatch("errorhandle", self.failArr[0].msg || "文件上传失败");
          self.successCount = 0;
          self.computedCount = 0;
          self.failCount = 0;
          self.failArr = [];
          self.successArr = [];
          self.uploading = false;
        }
      };
      const errorUpload = function(err) {
        console.error("上传失败", err);
        self.failCount++;
        self.__dispatch("errorhandle", err);
        self.successCount = 0;
        self.successArr = [];
      };

      let data;
      if (isBinary) {
        data = {
          type: file["type"],
          filename: file["name"],
          filed: this.inputOfFile,
          base64Code: base64Code
        };
      } else {
        data = new FormData();
        data.append(this.name, file);
      }
      xhr(
        "POST",
        this.url,
        this.headers,
        data,
        done,
        errorUpload,
        isBinary,
        this.credentials
      );
    }
  },
  mounted() {
    this.$input = this.__find("input");
  }
};
</script>
